module.exports = __webpack_public_path__ + "img/landscape_4.32ce9e55.jpg";